
















export default {
  name: "Sidebar"
};
